/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommentThreadNotificationActionData } from './CommentThreadNotificationActionData';
import {
    CommentThreadNotificationActionDataFromJSON,
    CommentThreadNotificationActionDataFromJSONTyped,
    CommentThreadNotificationActionDataToJSON,
} from './CommentThreadNotificationActionData';

/**
 * 
 * @export
 * @interface CommentThreadNotificationAction
 */
export interface CommentThreadNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof CommentThreadNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof CommentThreadNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {CommentThreadNotificationActionData}
     * @memberof CommentThreadNotificationAction
     */
    data: CommentThreadNotificationActionData;
}

/**
 * Check if a given object implements the CommentThreadNotificationAction interface.
 */
export function instanceOfCommentThreadNotificationAction(value: object): value is CommentThreadNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function CommentThreadNotificationActionFromJSON(json: any): CommentThreadNotificationAction {
    return CommentThreadNotificationActionFromJSONTyped(json, false);
}

export function CommentThreadNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentThreadNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': CommentThreadNotificationActionDataFromJSON(json['data']),
    };
}

export function CommentThreadNotificationActionToJSON(value?: CommentThreadNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': CommentThreadNotificationActionDataToJSON(value.data),
    };
}

